
























































































































































































































































import Common from '@/utilities/Common';
import { Component, Watch, Ref } from 'vue-property-decorator';
import ListPageBase from '@/components/ListPageBase';
import DataTable from '@/components/Common/DataTable.vue';
import { OrderService } from '@/services/OrderService';
import { OrderCasesService } from '@/services/OderCasesService';
import { Order } from '../models/Orders/Order';
import { OrderCaseImportFailure } from '@/models/Orders/OrderCaseImportFailure';
import { UnitaryPatentConstants } from '@/constants/UnitaryPatentConstants';
import { OrderStatusEnum } from '../models/Orders/OrderStatusEnum';
import { AddComment } from '@/models/AddComment';
import FileSaver, { saveAs } from 'file-saver';
@Component({
    components: {
        DataTable
    }
})
export default class OrderDetail extends ListPageBase {
    @Ref('formElement') private readonly formElement: any;
    private orderService: OrderService = new OrderService();
    private orderCaseService: OrderCasesService = new OrderCasesService();
    private fileRequiredRule: any = (v) => (!!v && !!v.type) || 'Please select a file!';
    private importModal: boolean = false;
    private tableLoading: boolean = false;
    private successfulImportMsg: string = '';
    private importResult: boolean = false;
    private isSuccessfulImport: boolean = false;
    private onImportProcessing: boolean = false;
    private loadingModule: boolean = false;
    private specialNoteModal: boolean = false;
    private loadingFile: boolean = false;
    private linkGenerated: boolean = false;
    private enableComment: boolean = true;
    private generationPending: boolean = false;
    private commentOrder: string = "";
    private file: File | any = null;
    private generatedLink: string = "";
    private errorList: OrderCaseImportFailure[] = [];
    private acceptedFileRule(v): any {
        return (!!v && ['application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', 'application/vnd.ms-excel', 'text/csv'].includes(v.type))
            || 'Selected invalid file. Please select xls/xlsx/csv file only.';
    }
    private get defaultHeaders(): Array<any> {
        return [
            {
                text: "Client Reference",
                value: "ClientReference",
                align: "start",
                sortable: false,
                width: "15%"
            },
            {
                text: "EP Publication #",
                value: "EPPublicationNumber",
                align: "start",
                sortable: false,
                width: "10%"
            },
            {
                text: "SPC Number",
                value: "SPCNumber",
                align: "start",
                sortable: false,
                width: "10%"
            },
            {
                text: "SPC Country Code",
                value: "SPCCountryCode",
                align: "start",
                sortable: false,
                width: "10%"
            },
            {
                text: "Company Name",
                value: "CompanyName",
                align: "start",
                sortable: false,
                width: "15%"
            },
            {
                text: "Address",
                value: "Address",
                align: "start",
                sortable: false,
                width: "25%"
            },
            {
                text: "Email",
                value: "Email",
                align: "start",
                sortable: false,
                width: "15%"
            },
        ]
    }
    updatePageData(): void {
        this.$nextTick(() => {
            this.tableLoading = true;
        });

        this.orderCaseService.getOrderCases({
            pageNumber: this.pageNumber,
            pageSize: this.pageSize
        }, this.order.Id)
            .then(success => {
                this.pagedData = success;
            })
            .finally(() => {
                this.tableLoading = false;
            });
    }

    get formTitle(): string {
        throw new Error("Method not implemented.");
    }

    get loaderProgess(): boolean {
        return this.loadingFile;
    }

    private canGetReceipt(): boolean {
        let index = this.pagedData.Data.findIndex(x => x.DownloadUrl != null && x.DownloadUrl != "");

        if (index >= 0) {
            return true;
        }
        else {
            return false;
        }
    }

    loadData(): void { }

    order: Order = {
        OrderNumber: ''
    };

    @Watch('order')
    async onOrderChanged(value: Order): Promise<void> {
        if (value) {
            await this.loadInit()
        }
    }

    async beforeMount() {
        this.onLoading = true;
        const orderId = this.$route.params.order_id;

        if (!Common.hasValue(orderId)) {
            window.console.error('Order ID was not found: ' + orderId);
            this.$router.push({ name: 'NotFound' });
            return;
        }

        this.order = await this.orderService.getOrder(orderId);
        this.commentOrder = this.order.Comment;
        this.onLoading = false;
    }

    private onImportModal(): void {
        if (this.pagedData.TotalItemCount > 0) {
            this.showConfirmDialog('Importing a new document will erase and overwrite the current data.',
                (result) => {
                    if (result) {
                        this.importModal = true
                    }
                },
                'Are you sure ?',
                300,
                'Confirm',
                'Cancel');
        }
        else {
            this.importModal = true
        }
    }

    private async onImport(): Promise<void> {
        if (!this.formElement.validate()) {
            return;
        }

        if (this.file) {
            this.onImportProcessing = true;
            var selectedFile = (this.file as File);
            var data = new FormData();

            data.append("file", selectedFile);

            var totalCasesAdded = await
                this.orderCaseService.updateFile(this.order.Id, data)
                    .then(success => {
                        if (success.Success) {
                            this.successfulImportMsg = success.Data > 1 ? `${success.Data} cases` : `${success.Data} case`;
                            this.isSuccessfulImport = true;
                            this.importResult = true;
                            this.importModal = false;
                            this.$nextTick(() => {
                                this.pageNumber = 1;
                                this.updatePageData();
                            });

                            this.order.StatusId = OrderStatusEnum.Uploaded;
                            this.onImportProcessing = false;
                        }
                    })
                    .catch(err => {
                        if (err.Data && Array.isArray(err.Data)) {
                            this.errorList = err.Data;
                            this.isSuccessfulImport = false;
                            this.importResult = true;
                            this.onImportProcessing = false;
                        }
                        this.file = null;
                    })
        }
    }

    @Watch('importModal')
    onDialogValueChanged(newVal: boolean): void {
        if (!newVal) {
            this.resetAll();
        }
    }

    private resetAll(): void {
        this.file = null;
        this.formElement.resetValidation();
    }

    private onCancel(): void {
        this.importModal = false;
    }

    private onDownload(e: any): void {
        e.preventDefault();
        this.loadingModule = true;
        this.loadingFile = true;

        this.orderCaseService.downloadTemplate()
            .then(success => {
                var filename = '';
                var disposition = success.headers.get('Content-Disposition');
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
                success.blob().then((b: any) => {
                    FileSaver.saveAs(b, decodeURIComponent(filename));
                });
            })
            .catch(error => {
                this.loadingModule = false;
                this.loadingFile = false;
            }).finally(() => {
                this.loadingModule = false;
                this.loadingFile = false;
            });
    }

    private updateStatus(status: OrderStatusEnum) {
        this.orderService.updateOrderStatus({
            OrderID: this.order.Id,
            OrderStatus: status,
            SpecialNote: this.order.SpecialNote
        })
            .then(success => {
                this.$nextTick(() => { this.order.StatusId = status; });
                this.specialNoteModal = false;
            })
            .finally(() => {
                this.specialNoteModal = false;
            })
    }
    private onSendContract(): void {
        if (this.order.DeclarationOptionsDTO != null && this.order.DeclarationOptionsDTO.SendContract) {
            this.updateStatus(OrderStatusEnum.ToSign);
        }
        else {
            this.updateStatus(OrderStatusEnum.NoSignature);
        }
    }

    private defineDisabledContract(): boolean {
        if (this.order.DeclarationOptionsDTO != null && this.order.DeclarationOptionsDTO.SendContract == null) {
            return true;
        }
        else {
            return false;
        }
    }

    private onLodgeOrder(): void {
        this.updateStatus(OrderStatusEnum.ToLodge);
    }

    private onSignDigital(): void {
        this.updateStatus(OrderStatusEnum.DigitalSignature);
    }

    private onReadyToLodge(): void {
        this.updateStatus(OrderStatusEnum.ReadyToLodge);
    }

    private onViewReport(): void {
        this.loadingModule = true;
        this.loadingFile = true;

        this.orderCaseService.getReport(this.order.Id)
            .then(success => {
                var filename = '';
                var disposition = success.headers.get('Content-Disposition');
                var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
                var matches = filenameRegex.exec(disposition);

                if (matches != null && matches[1]) {
                    filename = matches[1].replace(/['"]/g, '');
                }
                success.blob().then((b: any) => {
                    FileSaver.saveAs(b, decodeURIComponent(filename));
                });
            })
            .catch(error => {
                this.loadingModule = false;
                this.loadingFile = false;
            }).finally(() => {
                this.loadingModule = false;
                this.loadingFile = false;
            });
    }

    private generateLink(): void {
        this.linkGenerated = true;
        this.generationPending = true;
        this.loadingFile = true;
        this.orderService.generateLink(this.order.Id).then(success => {
            this.loadingFile = false;
            this.generatedLink = success.Data;
            this.generationPending = false;
        })
        .catch(error => {
            this.generationPending = false;
            this.loadingFile = false;
            this.generatedLink = 'An error occured during generation of download link';
        }).finally(() => {
        });
    }

private onDownloadContract(): void {
        this.loadingModule = true;
        this.loadingFile = true;

    this.orderService.getOrderReceipts(this.order.Id)
        .then(success => {
            var filename = '';
            var disposition = success.headers.get('Content-Disposition');
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);

            if (matches != null && matches[1]) {
                filename = matches[1].replace(/['"]/g, '');
            }
            success.blob().then((b: any) => {
                FileSaver.saveAs(b, decodeURIComponent(filename));
            });
        })
        .catch(error => {
            this.loadingModule = false;
            this.loadingFile = false;
        }).finally(() => {
            this.loadingModule = false;
            this.loadingFile = false;
        });
    
}

private onSendReport(): void {
    this.updateStatus(OrderStatusEnum.ToReport);
    }

    private openSendReport(): void {
        this.specialNoteModal = true;
    }

    private get canSendContract(): boolean {
        if (this.order.DeclarationOptionsDTO != null && this.order.DeclarationOptionsDTO.SendContract == null) {
            return true;
        }
        else {
            if (this.order.isVerified)
                return ![OrderStatusEnum.Uploaded].includes(this.order.StatusId);
            else {
                return true;
            }
        }

    }

    private get canImport(): boolean {
        if (this.order.isVerified)
            return ![OrderStatusEnum.Uploaded, OrderStatusEnum.Created].includes(this.order.StatusId);
        else {
            if (this.order.StatusId != OrderStatusEnum.Created)
                return true;
            else
                return false;
        }
            
    }

    private get canDownloadReceipt(): boolean {
        if (this.order.NumberOfSuccessfullCase > 0)
            return ![OrderStatusEnum.Completed].includes(this.order.StatusId);
        else
            return true;
    }

    private get canLodge(): boolean {
        return ![OrderStatusEnum.ReadyToLodge].includes(this.order.StatusId);
    }

    private get canDigitalSign(): boolean {
        return ![OrderStatusEnum.NoSignature, OrderStatusEnum.Signed].includes(this.order.StatusId);
    }

    private get canReadyLodge(): boolean {
        return ![OrderStatusEnum.DigitalSignature].includes(this.order.StatusId);
    }

    private get canSendReport(): boolean {
        return ![OrderStatusEnum.Lodge].includes(this.order.StatusId);
    }

    private get canViewReport(): boolean {
        return ![OrderStatusEnum.Lodge, OrderStatusEnum.Failed, OrderStatusEnum.Completed].includes(this.order.StatusId);
    }

    private onSaveComment() {
        let item: AddComment = new AddComment(this.order.Id, this.commentOrder);
        this.orderService.addComment(item);

        this.enableComment = true;
    }

    private closeGenerated(): void {
        this.generationPending = false;
        this.loadingFile = false;
        this.linkGenerated = false;
    }

    onPageChanged(pNumber: number): void {
        this.pageNumber = pNumber;
        this.updatePageData();
    }

    onPageSizeChanged(pSize: number): void {
        this.pageSize = pSize;
        this.updatePageData();
    }


}
